/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './svg-icon.component.scss.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../app/shared/svg-icon/svg-icon.component';
const styles_SvgIconComponent:any[] = [i0.styles];
export const RenderType_SvgIconComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:2,
    styles:styles_SvgIconComponent,data:{}});
export function View_SvgIconComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(2,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,':svg:svg',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵeld(0,(null as any),(null as any),0,':svg:use',([] as any[]),[[1,':xlink:href',
          0]],(null as any),(null as any),(null as any),(null as any)))],(null as any),
      (_ck,_v) => {
        var _co:i2.SvgIconComponent = _v.component;
        const currVal_0:any = _co.path;
        _ck(_v,1,0,currVal_0);
      });
}
export function View_SvgIconComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'svg-icon',([] as any[]),
      (null as any),(null as any),(null as any),View_SvgIconComponent_0,RenderType_SvgIconComponent)),
      i1.ɵdid(114688,(null as any),0,i2.SvgIconComponent,[i1.ElementRef,i1.Renderer2],
          (null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const SvgIconComponentNgFactory:i1.ComponentFactory<i2.SvgIconComponent> = i1.ɵccf('svg-icon',
    i2.SvgIconComponent,View_SvgIconComponent_Host_0,{name:'name'},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL21udC9lL2FwcHMvaGVscGRlc2svY2xpZW50L3NyYy9hcHAvc2hhcmVkL3N2Zy1pY29uL3N2Zy1pY29uLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9tbnQvZS9hcHBzL2hlbHBkZXNrL2NsaWVudC9zcmMvYXBwL3NoYXJlZC9zdmctaWNvbi9zdmctaWNvbi5jb21wb25lbnQudHMiLCJuZzovLy9tbnQvZS9hcHBzL2hlbHBkZXNrL2NsaWVudC9zcmMvYXBwL3NoYXJlZC9zdmctaWNvbi9zdmctaWNvbi5jb21wb25lbnQuaHRtbCIsIm5nOi8vL21udC9lL2FwcHMvaGVscGRlc2svY2xpZW50L3NyYy9hcHAvc2hhcmVkL3N2Zy1pY29uL3N2Zy1pY29uLmNvbXBvbmVudC50cy5TdmdJY29uQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPHN2Zz48dXNlIFthdHRyLnhsaW5rOmhyZWZdPVwicGF0aFwiPjwvdXNlPjwvc3ZnPiIsIjxzdmctaWNvbj48L3N2Zy1pY29uPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7OztvQkNBQTtNQUFBLHdFQUFLO2FBQUE7VUFBQTs7O1FBQUs7UUFBTCxXQUFLLFNBQUw7Ozs7b0JDQUw7TUFBQTthQUFBO1VBQUE7SUFBQTs7OzsifQ==



// WEBPACK FOOTER //
// /mnt/e/apps/helpdesk/client/src/$$_gendir/app/shared/svg-icon/svg-icon.component.ngfactory.ts